'use client'

import { useState } from 'react'
import { Text } from '@/design-system'
import { SignInForm } from './SignInForm'
import { SignUpForm } from './SignUpForm'

type AuthMode = 'sign-in' | 'sign-up'

interface AuthCardProps {
  initialMode?: AuthMode
}

function TabButton({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        flex: 1,
        padding: '10px 12px',
        border: 'var(--border-w) solid var(--ink)',
        background: active ? 'var(--accent)' : 'var(--paper)',
        color: 'var(--ink)',
        cursor: 'pointer',
        boxShadow: active ? 'var(--shadow-sm)' : 'none'
      }}>
      <Text as="span" variant="tag">
        {children}
      </Text>
    </button>
  )
}

export function AuthCard({ initialMode = 'sign-in' }: AuthCardProps) {
  const [mode, setMode] = useState<AuthMode>(initialMode)

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 420,
        border: 'var(--border-lg) solid var(--ink)',
        background: 'var(--paper)',
        boxShadow: 'var(--shadow-md)',
        padding: 20,
        position: 'relative'
      }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
        <TabButton active={mode === 'sign-in'} onClick={() => setMode('sign-in')}>
          Sign in
        </TabButton>
        <TabButton active={mode === 'sign-up'} onClick={() => setMode('sign-up')}>
          Sign up
        </TabButton>
      </div>

      {mode === 'sign-in' ? <SignInForm /> : <SignUpForm />}
    </div>
  )
}
